<div class="container">
    <!----------- TABLA QUE VEN LOS USUARIOS ------------------------------------>
    <ng-container *ngIf="!isAdmin">
        <div class="table-responsive">
            <table id="customers" style="margin-top:10px;">
                <tr>
                    <td style="font-weight: bold;" class="text-center">Estado</td>
                    <td style="font-weight: bold;">Usuario</td>
                    <td style="font-weight: bold;">Categoría</td>
                    <td style="font-weight: bold;" class="text-center"><i class="material-icons">priority_high</i>
                    </td>
                    <td style="font-weight: bold;">Asunto</td>
                    <td style="font-weight: bold;">Fecha</td>
                    <td style="font-weight: bold;" class="text-center">
                        Acciones
                    </td>
                </tr>
                <tr *ngFor="let card of dataSource; trackBy: trackByIndex">
                    <ng-container *ngIf="card.resolved == false">
                        <td class="text-center"><i class="material-icons">clear</i></td>
                    </ng-container>
                    <ng-container *ngIf="card.resolved">
                        <td class="text-center" style="background-color: greenyellow;"><i
                                class="material-icons">done</i>
                        </td>
                    </ng-container>
                    <td>{{card.name}}</td>
                    <td>{{card.category}}</td>
                    <ng-container *ngIf="card.priority == 0">
                        <td style="background-color: yellow;"></td>
                    </ng-container>
                    <ng-container *ngIf="card.priority == 1">
                        <td style="background-color: orange;"></td>
                    </ng-container>
                    <ng-container *ngIf="card.priority == 2">
                        <td style="background-color: red;"></td>
                    </ng-container>
                    <td>{{card.subject}}</td>
                    <td>{{card.date | date:"dd/MM/yyyy '-' HH:mm"}}</td>
                    <td class="text-center">
                        <button button mat-stroked-button (click)="viewTicket(card.id)">Ver</button>
                        <ng-container *ngIf="isAdmin && !card.resolved">
                            <button button mat-stroked-button (click)="resolveTicket(card.id)">Resolver</button>
                        </ng-container>
                    </td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!------------------------------------------------------------------------------------------------>

    <!---------- TABLA TICKETS NO RESUELTOS SOLO VEN ADMINISTRADORES -------------------------------->
    <ng-container *ngIf="isAdmin">
        <br />
        <p class="text-center">Pendientes</p>
        <hr>
        <div class="table-responsive">
            <table id="customers" style="margin-top:10px;">
                <tr>
                    <td style="font-weight: bold;" class="text-center">Estado</td>
                    <td style="font-weight: bold;">Usuario</td>
                    <td style="font-weight:bold;">Categoría</td>
                    <td style="font-weight: bold;" class="text-center"><i class="material-icons">priority_high</i>
                    </td>
                    <td style="font-weight: bold;">Subject</td>
                    <td style="font-weight: bold;">Date</td>
                    <td style="font-weight: bold;" class="text-center">
                        Actions
                    </td>
                </tr>
                <tr *ngFor="let card of dataSource; trackBy: trackByIndex">
                    <ng-container *ngIf="!card.resolved">
                        <ng-container *ngIf="card.resolved == false">
                            <td class="text-center"><i class="material-icons">clear</i></td>
                        </ng-container>
                        <ng-container *ngIf="card.resolved">
                            <td class="text-center" style="background-color: greenyellow;"><i
                                    class="material-icons">done</i>
                            </td>
                        </ng-container>
                        <td>{{card.name}}</td>
                        <td>{{card.category}}</td>
                        <ng-container *ngIf="card.priority == 0">
                            <td style="background-color: yellow;"></td>
                        </ng-container>
                        <ng-container *ngIf="card.priority == 1">
                            <td style="background-color: orange;"></td>
                        </ng-container>
                        <ng-container *ngIf="card.priority == 2">
                            <td style="background-color: red;"></td>
                        </ng-container>
                        <td>{{card.subject}}</td>
                        <td>{{card.date | date:"dd/MM/yyyy '-' HH:mm"}}</td>
                        <td class="text-center">
                            <button button mat-stroked-button (click)="viewTicket(card.id)">Ver</button>
                            <ng-container *ngIf="isAdmin && !card.resolved">
                                <button button mat-stroked-button color="accent"
                                    (click)="resolveTicket(card.id)">Resolver</button>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </table>
        </div>
    </ng-container>
    <!--------------------------------------------------------------------------------------------->

    <!------- TABLA TICKETS RESUELTOS SOLO VEN ADMINISTRADORES ---------------------------------------->
    <ng-container *ngIf="isAdmin">
        <hr>
        <br />
        <p class="text-center">Resueltos</p>
        <div class="table-responsive">
            <table id="customers" style="margin-top:10px;">
                <tr>
                    <td style="font-weight: bold;" class="text-center">Estado</td>
                    <td style="font-weight: bold;">Usuario</td>
                    <td style="font-weight: bold;">Categoría</td>
                    <td style="font-weight: bold;" class="text-center"><i class="material-icons">priority_high</i>
                    </td>
                    <td style="font-weight: bold;">Asunto</td>
                    <td style="font-weight: bold;">Fecha</td>
                    <td style="font-weight: bold;" class="text-center">
                        Acciones
                    </td>
                </tr>
                <tr *ngFor="let card of dataSource; trackBy: trackByIndex">
                    <ng-container *ngIf="card.resolved">

                        <ng-container *ngIf="card.resolved == false">
                            <td class="text-center"><i class="material-icons">clear</i></td>
                        </ng-container>
                        <ng-container *ngIf="card.resolved">
                            <td class="text-center" style="background-color: greenyellow;"><i
                                    class="material-icons">done</i>
                            </td>
                        </ng-container>
                        <td>{{card.name}}</td>
                        <td>{{card.category}}</td>
                        <ng-container *ngIf="card.priority == 0">
                            <td style="background-color: yellow;"></td>
                        </ng-container>
                        <ng-container *ngIf="card.priority == 1">
                            <td style="background-color: orange;"></td>
                        </ng-container>
                        <ng-container *ngIf="card.priority == 2">
                            <td style="background-color: red;"></td>
                        </ng-container>
                        <td>{{card.subject}}</td>
                        <td>{{card.date | date:"dd/MM/yyyy '-' HH:mm"}}</td>
                        <td class="text-center">
                            <button button mat-stroked-button (click)="viewTicket(card.id)">Ver</button>
                            <ng-container *ngIf="isAdmin && !card.resolved">
                                <button button mat-stroked-button color="accent"
                                    (click)="resolveTicket(card.id)">Resolver</button>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </table>
        </div>
    </ng-container>
    <!----------------------------------------------------------------------------------------------->
    <button type="button" (click)="newTicket()" mat-stroked-button
        class="btn btn-warning btn-circle btn-lg fc-black p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
    </button>
</div>